import React from 'react';

const SubscribePage = () => {
  return (
    <div style={styles.container}>
      <h1>Upgrade to Continue</h1>
      <p>Your 7-day free trial has ended.</p>
      <p>To continue learning and access all premium content, please subscribe:</p>

      <a
        href="https://buy.stripe.com/6oU5kE1oFd3ybwL5QI9oc00" //Real Stripe checkout link for Academic Vocabulary Booster
        target="_blank"
        rel="noopener noreferrer"
        style={styles.button}
      >
        Subscribe for €9.99/month
      </a>

      <p style={styles.info}>
        After payment, we’ll unlock your account within a few minutes.  
        Need help? <a href="mailto:info@beckettacademia.com">Contact support</a>.
      </p>

      <p style={styles.smallText}>
        Not for you? <a href="/delete-account">Delete your account</a>.
      </p>
    </div>
  );
};

export default SubscribePage;

const styles = {
  container: {
    maxWidth: '500px',
    margin: '60px auto',
    textAlign: 'center',
    fontFamily: 'Georgia, serif',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    boxShadow: '0 0 12px rgba(0,0,0,0.1)',
  },
  button: {
    display: 'inline-block',
    backgroundColor: '#007bff',
    color: 'white',
    textDecoration: 'none',
    padding: '12px 24px',
    fontSize: '1rem',
    borderRadius: '8px',
    cursor: 'pointer',
    marginTop: '20px',
  },
  info: {
    marginTop: '20px',
    fontSize: '0.95rem',
    color: '#333',
    lineHeight: '1.6',
  },
  smallText: {
    marginTop: '20px',
    fontSize: '0.85rem',
    color: '#666',
  },
};
